import {React,useState, useEffect} from 'react';
import {useFormikContext} from 'formik';
import {useLocation } from 'react-router-dom';
import {useFilter, useRequired} from 'helpers/hooks';
import {FieldsWrapper} from 'legacy_components/FieldsWrapper';
import {Input} from 'legacy_components/Input';
//import {Select} from 'legacy_components/Select';
import {YesNo} from 'legacy_components/YesNo';
import {AutocompleteSelect} from 'legacy_components/AutocompleteSelect';

export const Accounting = (
    {user,accountCode, accountingYears, docTypes, editable, numSeries, vatClassification, vatKvClassification, fetchRequiredFields}
) => {
    let location = useLocation();
    const modify = location.pathname.split("/")[2] === "modify";

    const {handleChange,values} = useFormikContext();
    let requiredFields = fetchRequiredFields(user,values?.info["document_type"], values?.info["payment_type"])
    
    const [refresh,setRefresh] = useState(true)
    const numSeriesEditable = editable && values.info.client_company && values.info.document_type;
    const accountCodeEditable = editable && values.info.client_company && values.info.document_type;
    const vatClassificationEditable = editable && values.info.client_company && values.info.document_type;
    const vatKvClassificationEditable = editable && values.info.client_company && values.info.document_type;
    const vatClsFilterValue = docTypes.find((docType) => docType.slug === values.info.document_type)?.is_expense;

    const prefilteredNumSeries = useFilter(numSeries, {document_type: values.info.document_type});

    let doc_type = values.info.document_type;
    // eslint-disable-next-line
    switch(doc_type) {
        case 'vod':
            doc_type = 'fvy';
            break;
        case 'pod':
            doc_type = 'fpr'
            break;
    }
    const filteredAccountCode = useFilter(accountCode, {document_type: doc_type});
    const filteredVatClassification = useFilter(vatClassification, vatClsFilterValue === null?{}:{is_expense: vatClsFilterValue});
    const filteredVatKvClassification = useFilter(vatKvClassification, {document_type: doc_type});
    const numSeriesRequired = useRequired('num_series', requiredFields);
    const accountCodeRequired = useRequired('account_code', requiredFields);
    const vatClassificationRequired = useRequired('vat_classification', requiredFields);
    const vatKvClassificationRequired = useRequired('vat_kv_classification', requiredFields);

    const accountingYear = accountingYears.find((year) => year.id === parseInt(values.info.accounting_year))?.year;
    const filteredNumSeries = prefilteredNumSeries.filter(numSeries => numSeries.year >= accountingYear)

    const [previousDependencies, setPreviousDependencies] = useState({
        num_series: values.info.num_series,
        account_code: values.info.account_code,
        vat_classification: values.info.vat_classification,
        vat_kv_classification: values.info.vat_kv_classification,
        reverse_charge: values.info.reverse_charge,
    });

    let [manualFire, setManualFire] = useState(0);
    useEffect(() => {
        const dependencies = {
            num_series: values.info.num_series,
            account_code: values.info.account_code,
            vat_classification: values.info.vat_classification,
            vat_kv_classification: values.info.vat_kv_classification,
            reverse_charge: values.info.reverse_charge,
        };
    
        for (const key in dependencies) {
            if (dependencies[key] !== previousDependencies[key]) {
                values.changedValues.push(key);
            }
        }
        
        if (JSON.stringify(dependencies)!==JSON.stringify(previousDependencies)){
            setPreviousDependencies(dependencies);
            setRefresh(!refresh); 
        }
    }, [values.info, manualFire,previousDependencies,refresh,values.changedValues]);

    
    const handleAccountCodeChange = (e) => {
        //handleChange(e)
        values.items.forEach((i)=>{
            if (!i["account_code"]){
                i["account_code"] = e
            }
        })
    }

    const handleVatClassificationChange = (e) => {
        //handleChange(e)
        values.items.forEach((i)=>{
            if (!i["vat_classification"]){
                i["vat_classification"] = e
            }
        })
    }

    const handleVatKVClassificationChange = (e) => {
        //handleChange(e)
        values.items.forEach((i)=>{
            if (!i["vat_kv_classification"]){
                i["vat_kv_classification"] = e
            }
        })
    }

    const handleReverseChargeChange = (e) => {
        handleChange(e)
        values.items.forEach((i)=>{
            if (!i["reverse_charge"]){
                i["reverse_charge"] = e.target.value
            }
        })
    }

    
    return (
        <FieldsWrapper columns={2}>
            <Input
                name="info.num_series"
                component={AutocompleteSelect}
                isRequired={numSeriesRequired}
                data={filteredNumSeries}
                disabled={!numSeriesEditable}
                highlighted={(modify &&values.changedValues.includes("num_series"))}
                selectedValue={values.info["num_series"]} 
                        onChange={(newValue) => {
                            values.info["num_series"] = newValue
                            setRefresh(!refresh)
                            setManualFire(manualFire+1)
                        }} 
                >
            
                Číselná řada
            </Input>
            <Input
                name="info.account_code"
                component={AutocompleteSelect}
                isRequired={accountCodeRequired}
                data={filteredAccountCode}
                disabled={!accountCodeEditable}
                highlighted={(modify &&values.changedValues.includes("account_code"))}
                selectedValue={values.info["account_code"]} 
                        onChange={(newValue) => {
                            values.info["account_code"] = newValue
                            handleAccountCodeChange(newValue)
                            setRefresh(!refresh)
                            setManualFire(manualFire+1)
                        }} 
                >
            
                Předkontace
            </Input>
            <Input
                name="info.vat_classification"
                component={AutocompleteSelect}
                isRequired={vatClassificationRequired}
                data={filteredVatClassification}
                disabled={!vatClassificationEditable}
                selectedValue={values.info["vat_classification"]} 
                highlighted={(modify &&values.changedValues.includes("vat_classification"))}
                onChange={(newValue) => {
                    values.info["vat_classification"] = newValue
                    handleVatClassificationChange(newValue)
                    setRefresh(!refresh)
                    setManualFire(manualFire+1)
                }} 
        
            >
                Členění DPH
            </Input>
            { filteredVatKvClassification.length > 0 ? <Input
                name="info.vat_kv_classification"
                component={AutocompleteSelect}
                isRequired={vatKvClassificationRequired}
                data={filteredVatKvClassification}
                disabled={!vatKvClassificationEditable}
                selectedValue={values.info["vat_kv_classification"]} 
                highlighted={(modify &&values.changedValues.includes("vat_kv_classification"))}
                onChange={(newValue) => {
                    values.info["vat_kv_classification"] = newValue
                    handleVatKVClassificationChange(newValue)
                    setRefresh(!refresh)
                    setManualFire(manualFire+1)
                }}
            >
                Členění KV DPH
            </Input> : null }
            <YesNo name="info.reverse_charge" 
            heading="Přenesená daňová povinnost" 
            disabled={!editable} 
            onChange={handleReverseChargeChange}
            highlighted={(modify &&values.changedValues.includes("reverse_charge"))}
            />
        </FieldsWrapper>
    )
};